import LangEnum from '../../lang/LangEnum';
import { AvailabilityEnum } from '../products/ProductTypes';

export interface CatalogAvailabilityConditionConfig {
  type: AvailabilityEnum;
  labelLang: LangEnum;
}

export const CATALOG_AVAILABILITY_CONDITION_CONFIGS: CatalogAvailabilityConditionConfig[] = [
  { type: AvailabilityEnum.READY_FOR_DELIVERY, labelLang: LangEnum.GLOBAL_READY_FOR_DELIVERY },
  { type: AvailabilityEnum.FUTURE_STOCK, labelLang: LangEnum.GLOBAL_FUTURE_STOCK },
  { type: AvailabilityEnum.MATERIAL_PRE_ORDER, labelLang: LangEnum.GLOBAL_MATERIAL_PRE_ORDER },
];
